import React, {useEffect, useState} from "react";
import { Link } from "react-router-dom";
import PersonalInformationModelPopup from "components/modelpopup/PersonalInformationModelPopup";
import PersonalInfoModal from "components/modelpopup/personalInfoModal";
import { toast, Bounce } from "react-toastify";

import { ListItem, EmploymentDetails } from "./EmployeeProfileContent";
import {EmployeeAssets} from "./EmployeeAssets"
import {EmployeeLeave} from "./EmployeeLeave";
import { useSelector } from "react-redux";
import AddressModal from "components/modelpopup/emergencyContactModal"
import { toTitleCase } from "utils/common";
import { deleteAddressApi } from "api/services/employee";
import DeleteModal from "components/modelpopup/DeleteModal";
import EmpDocuments from "./employeeDocument"
import EmpExpenses from "./employeeExpenses"

const ProfileTab = ({userData, userSalaryData, addressData, addressLoading, fetchAddresses, fetchDetail}) => {
  const {
    user,
    userLoading
  } = useSelector((state) => state.user);

  const [personalInfoData, setPersonalInfo] = useState([]) 
  const [bankInfoData, setBankInfoData] = useState([])
  const [addressModal, setAddressModal] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState("")
  const [deleteModal, setDeleteModal] = useState(false);


  const [personalInfoModal, setPersonalInfoModal] = useState(false);


  console.log(userData, user, "UUUU")
  useEffect(()=>{
   const personal =  [
      // { id: 1, title: "Passport No.", text: "" },
      // { id: 2, title: "Passport Exp Date.", text: "" },
      { id: 3, title: "Phone", text: userData?.contact?.mobile_no, type:"tel" },
      { id: 4, title: "Email", text: userData?.contact?.private_email, type:"mailto" },
      { id: 5, title: "Address", text: [userData?.contact?.address_1, userData?.contact?.address_2, userData?.contact?.city]
            .map(item => item?.trim()).filter(Boolean).join(", ") || "N.A."}, 
      // { id: 6, title: "Postal code", text: userData?.contact?.post_code,},  
      { id: 7, title: "Nationality", text: userData?.nationality?.name },
      // { id: 8, title: "Religion", text: userData?.religion?.name },
      { id: 9, title: "Marital status", text: toTitleCase(userData?.marital_status||"") },
      // { id: 10, title: "Employment of spouse", text: "No" },
      { id: 11, title: "No. of children", text: userData?.no_of_dependent},
      { id: 12, title: "Blood group", text: userData?.blood_group  },
      // { id: 13, title: "Landline", text: userData?.contact?.landline_no },
  
    ]
    setPersonalInfo(personal)
    const bank = [
      { id: 1, title: "Bank name", text: userData?.bank_detail?.bank_branch_name },
     // { id: 2, title: "Bank account No.", text: userData?.bank_detail?.bank_account_no},
      { id: 3, title: "IBAN", text: userData?.bank_detail?.iban},
     // { id: 4, title: "Swift code", text: userData?.bank_detail?.swift_code },
    ]
    setBankInfoData(bank)

  },[userData])
  
  // const personalInfoData = [
  //   { id: 1, title: "Passport No.", text: "9876543210" },
  //   { id: 2, title: "Passport Exp Date.", text: "9876543210" },
  //   { id: 3, title: "Tel", text: "9876543210" },
  //   { id: 4, title: "Nationality", text: "Indian" },
  //   { id: 5, title: "Religion", text: "Christian" },
  //   { id: 6, title: "Marital status", text: "Married" },
  //   { id: 7, title: "Employment of spouse", text: "No" },
  //   { id: 8, title: "No. of children", text: "2" },
  // ];

  const primaryContactData = [
    { id: 1, title: "Name", text: "" },
    { id: 2, title: "Relationship", text: "" },
    { id: 3, title: "Phone", text: "" },
  ];

  const secondaryContactData = [
    { id: 1, title: "Name", text: "" },
    { id: 2, title: "Relationship", text: "" },
    { id: 3, title: "Phone", text: "" },
  ];
  // const bankInfoData = [
  //   { id: 1, title: "Bank name", text: "ICICI Bank" },
  //   { id: 2, title: "Bank account No.", text: "159843014641" },
  //   { id: 3, title: "IFSC Code", text: "ICI24504" },
  //   { id: 4, title: "PAN No", text: "TC000Y56" },
  // ];
  const familyInfoData = [
    {
      id: 1,
      name: "Leo",
      relationship: "Brother",
      dob: "Feb 16th, 2019",
      phone: "9876543210",
    },
  ];

  const educationData = [
    {
      id: 1,
      name: "International College of Arts and Science (UG)",
      description: "Bsc Computer Science",
      time: "2020 - 2023",
    },
    {
      id: 2,
      name: "International College of Arts and Science (PG)",
      description: "Msc Computer Science",
      time: "2021 - 2023",
    },
    // Add more education info data as needed
  ];
  const experienceData = [
    {
      id: 1,
      name: "Web Designer at Zen Corporation",
      time: "Jan 2023 - Present (5 years 2 months)",
    },
    {
      id: 2,
      name: "Web Designer at Ron-tech",
      time: "Jan 2023 - Present (5 years 2 months)",
    },
    {
      id: 3,
      name: "Web Designer at Dalt Technology",
      time: "2023 2023 - Present (5 years 2 months)",
    },
    // Add more experience info data as needed
  ];


  const deleteAddress = () => {
    deleteAddressApi(selectedAddress?.id).then(res=>{
      toast.success('Contact deleted!', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
          });
          fetchAddresses()
          setDeleteModal(false)
    }).catch(err=>{
      toast.error('Error deleting contact!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        });
    })
  }

  return (
    <>
      <div className="tab-content">
        <div
          id="emp_profile"
          className="pro-overview tab-pane fade show active"
        >
          <div className="row">
            <div className="col-md-6 d-flex">
              <div className="card profile-box flex-fill">
                <div className="card-body">
                  <h3 className="card-title">
                    Personal Information{" "}
                    {
                      (user?.id == userData.id || user?.role?.access_scope == "all") &&
                      <Link
                      onClick={()=> setPersonalInfoModal(true)}
                      to="#"
                      className="edit-icon"
                      // data-bs-toggle="modal"
                      // data-bs-target="#personal_info_modal"
                    >
                      <i className="fa fa-pencil" />
                    </Link>

                    }
                  </h3>
                  <ul className="personal-info">
                    {personalInfoData.map((item, index) => (
                      <ListItem
                        id={item.id}
                        key={index}
                        title={item.title}
                        type={item.type}
                        text={item.text}
                      />
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-6 d-flex">
              <div className="card profile-box flex-fill">
                <div className="card-body  overflow-auto" style={{ minHeight: "150px", maxHeight: "400px" }} // ✅ Scroll if more than 3 records
>
                  <h3 className="card-title">
                    Emergency Contact{" "}

                    {
                      userData?.id === user?.id &&
                      <Link
                      to="#"
                      className="edit-icon"
                      onClick={()=>setAddressModal(true)}
                    >
                      <i className="fa fa-plus" />
                    </Link>
                    }



                  </h3>
                  {addressLoading ? (
          <div className="text-center">
            <div className="spinner-border text-primary" role="status"></div>
          </div>
        ) : addressData.length === 0 ? (
          <p className="text-muted text-center">No addresses found</p>
        ) : (
          addressData.map((address, index) => (
            <div key={index} className="border-bottom pb-2 mb-2">
               {
                      userData?.id === user?.id &&
                      <Link
                      to="#"
                      className="edit-icon ms-2"
                      onClick={()=>{
                        setSelectedAddress(address)
                        setDeleteModal(true)
                        // deleteAddress(address.id)
                      }
                      }
                    >
                      <i className="fa fa-trash" />
                    </Link>
                    }
                {
                      userData?.id === user?.id &&
                      <Link
                      to="#"
                      className="edit-icon"
                      onClick={()=>{
                        setSelectedAddress(address)
                        setAddressModal(true)}}
                    >
                      <i className="fa fa-pencil" />
                    </Link>
                    }
                    
              <p className="mb-1">
                <strong>Name:</strong> {address.name}
              </p>
              <p className="mb-1">
                <strong>Address:</strong> {address.address_1}, {address.address_2}
              </p>
              <p className="mb-1">
                <strong>City:</strong> {address.city}
              </p>
              <p className="mb-1">
                <strong>Country:</strong> {address.country?.name}
              </p>
              <p className="mb-1">
                <strong> Contact Name:</strong> {address.emergency_contact_name} 
              </p>
              <p className="mb-1">
                <strong> Contact Number:</strong> <a href={`tel:${address.emergency_contact_number}`} className="text-primary">{address.emergency_contact_number} </a>
              </p>
              <p className="mb-1">
                <strong> Home Contact Number:</strong> <a href={`tel:${address.emergency_contact_number_2}`} className="text-primary">{address.emergency_contact_number_2} </a>
              </p>
            </div>
          ))
        )}

                  {/* <h5 className="section-title">Primary</h5>
                  <ul className="personal-info">
                    {primaryContactData.map((item, index) => (
                      <ListItem
                        id={item.id}
                        key={index}
                        title={item.title}
                        text={item.text}
                      />
                    ))}
                  </ul>
                  <hr />
                  <h5 className="section-title">Secondary</h5>
                  <ul className="personal-info">
                    {secondaryContactData.map((item, index) => (
                      <ListItem
                        id={item.id}
                        key={index}
                        title={item.title}
                        text={item.text}
                      />
                    ))}
                  </ul> */}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 d-flex">
              <div className="card profile-box flex-fill">
                <div className="card-body">
                  <h3 className="card-title">Bank information</h3>
                  <ul className="personal-info">
                    {bankInfoData.map((item, index) => (
                      <ListItem
                        id={item.id}
                        key={index}
                        title={item.title}
                        text={item.text}
                      />
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            {/* <div className="col-md-6 d-flex">
              <div className="card profile-box flex-fill">
                <div className="card-body">
                  <h3 className="card-title">
                    Family Informations{" "}
                   
                  </h3>
                  <div className="table-responsive">
                    <table className="table table-nowrap">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Relationship</th>
                          <th>Date of Birth</th>
                          <th>Phone</th>
                          <th />
                        </tr>
                      </thead>
                      <tbody>
                        {familyInfoData.map((item) => (
                          <tr key={item.id}>
                            <td>{item.name}</td>
                            <td>{item.relationship}</td>
                            <td>{item.dob}</td>
                            <td>{item.phone}</td>
                            <td className="text-end">
                              <div className="dropdown dropdown-action">
                                <Link
                                  aria-expanded="false"
                                  data-bs-toggle="dropdown"
                                  className="action-icon dropdown-toggle"
                                  to="#"
                                >
                                  <i className="material-icons">more_vert</i>
                                </Link>
                                <div className="dropdown-menu dropdown-menu-right">
                                  <Link to="#" className="dropdown-item">
                                    <i className="fa fa-pencil m-r-5" /> Edit
                                  </Link>
                                  <Link to="#" className="dropdown-item">
                                    <i className="fa fa-trash m-r-5" /> Delete
                                  </Link>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
          {/* <div className="row">
            <div className="col-md-6 d-flex">
              <div className="card profile-box flex-fill">
                <div className="card-body">
                  <h3 className="card-title">
                    Education Informations{" "}
                    <Link
                      to="#"
                      className="edit-icon"
                      data-bs-toggle="modal"
                      data-bs-target="#education_info"
                    >
                      <i className="fa fa-pencil" />
                    </Link>
                  </h3>
                  <div className="experience-box">
                    <ul className="experience-list">
                      {educationData.map((item) => (
                        <li key={item.id}>
                          <div className="experience-user">
                            <div className="before-circle" />
                          </div>
                          <div className="experience-content">
                            <div className="timeline-content">
                              <Link to="/" className="name">
                                {item.name}
                              </Link>
                              <div>{item.description}</div>
                              <span className="time">{item.time}</span>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 d-flex">
              <div className="card profile-box flex-fill">
                <div className="card-body">
                  <h3 className="card-title">
                    Experience{" "}
                    <Link
                      to="#"
                      className="edit-icon"
                      data-bs-toggle="modal"
                      data-bs-target="#experience_info"
                    >
                      <i className="fa fa-pencil" />
                    </Link>
                  </h3>
                  <div className="experience-box">
                    <ul className="experience-list">
                      {experienceData.map((item) => (
                        <li key={item.id}>
                          <div className="experience-user">
                            <div className="before-circle" />
                          </div>
                          <div className="experience-content">
                            <div className="timeline-content">
                              <Link to="/" className="name">
                                {item.name}
                              </Link>
                              <span className="time">{item.time}</span>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
        <EmploymentDetails userData={userData} userSalaryData={userSalaryData} fetchInfo={fetchDetail}/>
        
        <EmployeeAssets userData={userData}/>

        <EmployeeLeave userData={userData}/>

        <div
        className="tab-pane fade" id="emp_documents"
          // id="emp_documents"
          // className="pro-overview tab-pane fade show active"
        >
          <EmpDocuments userData={userData}/>

        </div>
        <div
          id="emp_expenses"
          className="tab-pane fade"
        >
          <EmpExpenses userData={userData}/>
        </div>
        {/*  Bank Tab */}
      </div>
      {/* Model Popup*/}
      <PersonalInformationModelPopup />

      <PersonalInfoModal 
       infoModal={personalInfoModal}
       setInfoModal={setPersonalInfoModal}
       selectedInfo={userData}
       fetchInfo={fetchDetail}
      />

      <AddressModal fetchAddresses={fetchAddresses} userData={userData} addressModal={addressModal} setAddressModal={setAddressModal} selectedAddress={selectedAddress} setSelectedAddress={setSelectedAddress} />
      <DeleteModal
        deleteModal={deleteModal}
        setDeleteModal={setDeleteModal}
        deleteHandler={deleteAddress}
        Name="Delete Emergency Contact"
      />
    </>
  );
};

export default ProfileTab;
